import { AxiosResponse } from "axios";
import "../../../styles/historyDrawer.css";
import { Drawer, List, Badge } from "antd";
import axiosInstance from "../../../utils/axiosInstance";
import { useEffect, useState } from "react";
import FileItem from "./FileItem";

interface DrawerMenuProps {
  open: boolean;
  onClose: () => void;
}

interface FileData {
  name: string;
  created: string;
  url: string;
  notificationDelivered: boolean;
}

const DrawerMenu: React.FC<DrawerMenuProps> = ({ open, onClose }) => {
  const [files, setFiles] = useState<FileData[]>([]);

  const updateList = async (): Promise<Array<FileData>> => {
    let result: Array<FileData> = [];

    const response: any = await axiosInstance.get("/exports/list");

    if (response && response.data.data.medias.length > 0) {
      const sortedFiles: Array<FileData> = response.data.data.medias.sort(
        (a: FileData, b: FileData) => {
          return new Date(b.created).getTime() - new Date(a.created).getTime();
        }
      );

      setFiles(sortedFiles);

      result = sortedFiles;
    }

    return result;
  };

  const markFilesAsNotified = async () => {
    try {
      const fileList: Array<FileData> = await updateList();

      if (files.length <= 0) {
        return;
      }

      const mediaNames: Array<string> = fileList
        .filter((file: FileData) => file.notificationDelivered === false)
        .map((file: FileData) => file.name);

      if (mediaNames.length <= 0) {
        return;
      }

      const response: any = await axiosInstance({
        method: "post",
        url: "/exports/updateDeliveredNotifications",
        data: {
          mediaNames: mediaNames,
        },
      });
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    if (open) {
      markFilesAsNotified();
    }
  }, [open]);

  return (
    <Drawer
      key={6}
      className="customDrawer"
      title="Administrador de descargas"
      style={{ position: "absolute" }}
      width={450}
      placement="right"
      closable={true}
      onClose={onClose}
      open={open}
      getContainer={false}
    >
      <List
        size="large"
        dataSource={files}
        renderItem={(file: FileData) => (
          <FileItem
            key={file.name}
            name={file.name}
            created={file.created}
            url={file.url}
            notificationDelivered={file.notificationDelivered}
          />
        )}
      />
    </Drawer>
  );
};

export default DrawerMenu;
